import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, memo } from 'react';
import { observer } from 'mobx-react-lite';
const KeyboardServiceContext = createContext(undefined);
export const useKeyboardService = () => {
    const value = useContext(KeyboardServiceContext);
    if (!value) {
        throw new Error('Component must be a child of <KeyboardServiceProvider />');
    }
    return value;
};
const MemoizedChildren = memo(({ children }) => _jsx(_Fragment, { children: children }));
const KeyboardServiceProvider = ({ service, children }) => {
    return (_jsx(KeyboardServiceContext.Provider, { value: service, children: _jsx(MemoizedChildren, { children: children }) }));
};
export default observer(KeyboardServiceProvider);
